import script from "./CartPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPopover.vue?vue&type=script&setup=true&lang=js"

import "./CartPopover.vue?vue&type=style&index=0&id=307b03cd&lang=css"

const __exports__ = script;

export default __exports__